import HelloController from "./hello_controller";
import MapController from "./map_controller";
import NestedFieldsController from "./nested_fields_controller";
import FeedbackChannelController from "./feedback_channel_controller";

// Called explicitly from the entrypoint after Application.start() - importing
// this module can't rely on window.Stimulus already being set, since static
// imports always evaluate before the importing file's own top-level code.
export function registerControllers(application) {
  application.register("hello", HelloController);
  application.register("map", MapController);
  application.register("nested-fields", NestedFieldsController);
  application.register("feedback-channel", FeedbackChannelController);
}
